import { motion } from "framer-motion";

import chargerFrontView from "../../assests/image.png";

const ChargerImage3D = ({ className = "" }) => {
  return (
    <motion.div
      className={`charger-image-3d ${className}`.trim()}
      initial={{ opacity: 0, y: 24, rotateX: 8, rotateY: -10 }}
      animate={{
        opacity: 1,
        y: [0, -8, 0],
        rotateX: [4, 2, 4],
        rotateY: [-8, -5, -8],
      }}
      transition={{
        opacity: { duration: 0.45 },
        y: { duration: 5.5, repeat: Infinity, ease: "easeInOut" },
        rotateX: { duration: 5.5, repeat: Infinity, ease: "easeInOut" },
        rotateY: { duration: 5.5, repeat: Infinity, ease: "easeInOut" },
      }}
    >
      <span className="charger-image-3d-halo" />
      <span className="charger-image-3d-depth" />
      <img src={chargerFrontView} alt="Ultrafast charger front view" />
      <span className="charger-image-3d-floor" />
    </motion.div>
  );
};

export default ChargerImage3D;
